import React, { useEffect, useState } from 'react';
import { api } from '../../../context/AuthContext';

const BEREICH = { team: 'Kanzlei-Team', rollen: 'Rollen', mandantenkonto: 'Mandantenkonto', loeschkonzept: 'Löschkonzept' };
const LABEL = { kanzlei_rolle: 'Rolle', role: 'Systemrolle', aktenzugriff: 'Aktenzugriff', aktenzugriff_gebiete: 'Rechtsgebiete', rechte_abweichend: 'Abweichende Rechte', gesperrt: 'Gesperrt', aktiv: 'Aktiv', rechte: 'Rechte', akten: 'Akten', eingeladen: 'Eingeladen als', zustimmung_textform: 'Zustimmung in Textform', zugang: 'Zugang', tage: 'Löschfristen (Tage)', auto: 'Automatischer Lauf' };
const wert = (v) => (v == null ? '–' : v === true ? 'ja' : v === false ? 'nein' : Array.isArray(v) ? (v.join(', ') || '–') : typeof v === 'object' ? (Object.entries(v).map(([k, x]) => `${LABEL[k] || k}: ${wert(x)}`).join(', ') || '–') : String(v));
const txt = (v) => (v && typeof v === 'object' && !Array.isArray(v) ? Object.entries(v).map(([k, x]) => `${LABEL[k] || k}: ${wert(x)}`).join(' · ') || '–' : wert(v));

export const RechteProtokoll = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/kanzlei/rechte/protokoll').then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return null;
  if (!items.length) return <p className="text-sm text-gray-500" data-testid="protokoll-leer">Noch keine Änderungen protokolliert.</p>;
  return (
    <ul className="bg-white border border-gray-200 rounded-2xl divide-y divide-gray-100 text-[13px]" data-testid="rechte-protokoll">
      {items.map((p) => (
        <li key={p.id} className="p-4 grid sm:grid-cols-[150px_1fr] gap-1">
          <span className="text-xs text-gray-500">{new Date(p.am).toLocaleString('de-DE')}</span>
          <div>
            <p className="text-[#1B3A5C]"><span className="text-[10px] uppercase tracking-wider text-[#b8893d] mr-2">{BEREICH[p.bereich] || p.bereich}</span>{p.ziel} · von {p.von}</p>
            <p className="text-xs text-gray-500 break-all mt-0.5">vorher: {txt(p.vorher)}</p>
            <p className="text-xs text-gray-700 break-all">nachher: {txt(p.nachher)}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};
